import React, { useCallback } from 'react';

import { Text } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

interface TimeFormatterProps {
    minutes: number;
}

const MINUTES_IN_HOUR = 60;
const MINUTES_IN_DAY = 24 * MINUTES_IN_HOUR;

const TrlKeys = {
    days: 'admin.moderation.banner.time.days',
    hours: 'admin.moderation.banner.time.hours',
    minutes: 'admin.moderation.banner.time.minutes',
};

export const TimeFormatter: React.FC<TimeFormatterProps> = ({ minutes }) => {
    const trls = useTrls();

    const formatTime = useCallback(
        (totalMinutes: number): string => {
            const days = Math.floor(totalMinutes / MINUTES_IN_DAY);
            const hours = Math.floor((totalMinutes - days * MINUTES_IN_DAY) / MINUTES_IN_HOUR);
            const mins = totalMinutes - days * MINUTES_IN_DAY - hours * MINUTES_IN_HOUR;

            const parts: string[] = [];

            if (days > 0) {
                parts.push(trls(TrlKeys.days, [days]));
            }
            if (hours > 0) {
                parts.push(trls(TrlKeys.hours, [hours]));
            }
            parts.push(trls(TrlKeys.minutes, [mins]));
            return parts.join(' ');
        },
        [trls]
    );

    return (
        <Text style="secondary" typography="label-3-regular">
            {formatTime(minutes)}
        </Text>
    );
};
